import { Env } from 'types';

export const validateEnv = (envConfig: Partial<Env>, defaultConfig?: Partial<Env>): Env => {
  envConfig.apiUrl ||= defaultConfig?.apiUrl;
  if (!envConfig.apiUrl) {
    throw new Error('API Url not defined in ENV config');
  }

  envConfig.test ||= defaultConfig?.test;

  envConfig.featureFlags ||= defaultConfig?.featureFlags;

  envConfig.auth ||= defaultConfig?.auth;

  envConfig.routerBasePath ||= defaultConfig?.routerBasePath;

  envConfig.versionId = defaultConfig?.versionId;

  return envConfig as Env;
};
